var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isActive,
          expression: "isActive",
        },
      ],
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("div", { staticClass: "model-content" }, [
        _c("div", { staticClass: "modal-card" }, [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "div",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _c("div", [_vm._v(_vm._s(_vm.title))]),
              ]
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c("div", [_vm._v(_vm._s(_vm.message))]),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              !_vm.licenceExpired
                ? _c(
                    "button",
                    {
                      staticClass: "button is-success tooltip",
                      attrs: { "data-tooltip": "Save & continue" },
                      on: {
                        click: function ($event) {
                          return _vm.saveContinue()
                        },
                      },
                    },
                    [_vm._v("Save & Continue")]
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "button is-warning tooltip",
                  attrs: {
                    "data-tooltip": "Continue without save",
                    disabled: _vm.skipDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.skipSave()
                    },
                  },
                },
                [_vm._v("Skip")]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip is-tooltip-topright",
                  attrs: { "data-tooltip": "Don't continue" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }